import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import {IProfileUserData} from "../../../contracts/data/user";
import InnerProfileUserForm from "../../../components/FormTemplates/user/InnerProfileUserForm";
import {isNotEmpty} from "../../../helpers/functions";


const profileUserFormValidationSchema = yup.object().shape({
    first_name: yup.string().required("نام الزامی میباشد"),
    last_name: yup.string().required("نام خانوادگی الزامی میباشد"),
    email: yup.string().email("ایمیل وارد شده نادرست می باشد").nullable(),
})

interface IProfileUserFormProps {
    userId: number
}

const ProfileUserForm = withFormik<IProfileUserFormProps, IProfileUserData>({
    mapPropsToValues: props => ({
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        avatar: '',
        avatar_url: '',
        job: '',
        income: 0,
        education: 0,
        gender: 1,
        address: '',
        state: 0,
        birth_date_jalali: '',
    }),
    mapPropsToStatus: props => ({}),
    validationSchema: profileUserFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.avatar && isNotEmpty(values.avatar) && typeof values.avatar === 'object') {
            formData.append('avatar', values.avatar)
        }

        formData.append('data', JSON.stringify(values));
        await httpClient().put(`${usersApi.profile}/${formikBag.props?.userId}`, formData)
            .then(response => {
                if (response.status === 200) {
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response.data
                    })
                }
            })
            .catch(error => console.log(error))
    },
    displayName: 'ProfileUserForm'
})(InnerProfileUserForm)

export default ProfileUserForm